import { Chip, Radio, RadioGroup } from '@heroui/react'
import { MultiSelect, type PickOption } from '../ui/MultiSelect'
import '../styles/people.css'

// Local pieces for the People category (People, Roles, Directory, Approvals).

/** The shared MultiSelect, kept from submitting the dialog's form on Enter in its search. */
export function PickMany(props: Parameters<typeof MultiSelect>[0]) {
  return (
    <div
      onKeyDown={(e) => {
        if (e.key === 'Enter' && (e.target as HTMLElement).tagName === 'INPUT') e.preventDefault()
      }}
    >
      <MultiSelect {...props} />
    </div>
  )
}

/** One choice among a few (a role, what a group gives), as a HeroUI RadioGroup in a row. */
export function ChoiceChips({
  name,
  options,
  value,
  onChange,
  label,
  disabled,
}: {
  name: string
  options: readonly PickOption[]
  value: string
  onChange: (next: string) => void
  label: string
  disabled?: boolean
}) {
  return (
    <RadioGroup
      className="pk-choice"
      orientation="horizontal"
      name={name}
      aria-label={label}
      value={value === '' ? null : value}
      onChange={onChange}
      isDisabled={disabled}
    >
      {options.map((o) => (
        <Radio key={o.value} value={o.value} isDisabled={o.disabled}>
          <Radio.Content>
            <Radio.Control>
              <Radio.Indicator />
            </Radio.Control>
            {o.label}
            {o.note && <small>{o.note}</small>}
          </Radio.Content>
        </Radio>
      ))}
    </RadioGroup>
  )
}

/** A short list of names as chips, the rest counted. */
export function ChipList({ names, max = 2, quiet }: { names: string[]; max?: number; quiet?: string }) {
  if (names.length === 0) return quiet ? <span className="pk-quiet">{quiet}</span> : null
  const shown = names.slice(0, max)
  const rest = names.length - shown.length
  return (
    <span className="pk-chiplist" title={names.join(', ')}>
      {shown.map((n, i) => (
        <Chip key={i} size="sm" variant="secondary">
          {n}
        </Chip>
      ))}
      {rest > 0 && (
        <Chip size="sm" variant="tertiary">
          +{rest}
        </Chip>
      )}
    </span>
  )
}
